// extracted by mini-css-extract-plugin
module.exports = {"container":"Tabs_container__4EEmE","tab":"Tabs_tab__jwiYw","active":"Tabs_active__h6Ceh"};